import React from 'react';
import { FadeIn } from '../components/ui/FadeIn';
import { Gift } from 'lucide-react';
const BONUSES = [{
  title: 'Ritual Mamá & Bebé de 7 Minutos',
  description: 'Pequeños momentos diarios para conectar, cuidar y fortalecer tu vínculo.',
  image: 'https://cdn.magicpatterns.com/uploads/rJCdbFKbXFQnb2QXTtkMGS/ChatGPT_Image_Jun_21,_2026,_11_44_47_PM.png',
  alt: 'Portada del bono Ritual Mamá & Bebé de 7 Minutos'
}, {
  title: '40 Cartas Guiadas Para Mi Bebé',
  description: 'Conecta, sueña y prepara tu corazón para recibir a tu bebé.',
  image: 'https://cdn.magicpatterns.com/uploads/qw3xkVNU4kwLbFWQuFGQ8p/ChatGPT_Image_Jun_21,_2026,_11_44_59_PM.png',
  alt: 'Portada del bono 40 Cartas Guiadas Para Mi Bebé'
}, {
  title: 'Álbum Digital de Ecografías y Recuerdos',
  description: 'Guarda cada imagen, cada latido y cada momento para siempre.',
  image: 'https://cdn.magicpatterns.com/uploads/vZF3GyVHSRtNJZkz2xKXEY/ChatGPT_Image_Jun_21,_2026,_11_46_18_PM.png',
  alt: 'Portada del bono Álbum Digital de Ecografías y Recuerdos'
}];
export function Bonuses() {
  return <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-95">
      <FadeIn data-id="element-96">
        <div className="text-center mb-12" data-id="element-97">
          <span className="text-sm font-bold tracking-widest text-brand-rose uppercase mb-2 block" data-id="element-98">
            Regalos Exclusivos
          </span>
          <h2 className="text-3xl md:text-4xl font-serif text-brand-burgundy" data-id="element-99">
            Bonos Especiales
          </h2>
          <p className="text-gray-600 mt-3 max-w-xl mx-auto" data-id="element-100">
            Recibe estos 3 libros de regalo al comenzar tu Método de las 40
            Semanas de Conexión™.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-101">
          {BONUSES.map((bono, idx) => <FadeIn key={idx} delay={idx * 0.15} data-id="element-102">
              <div className="relative bg-white border-2 border-brand-gold/30 rounded-2xl overflow-hidden group hover:border-brand-rose hover:shadow-md transition-all h-full flex flex-col" data-id="element-103">
                <div className="absolute top-3 right-3 z-10 bg-brand-rose text-white text-[11px] font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow-sm flex items-center gap-1" data-id="element-104">
                  <Gift className="w-3 h-3" strokeWidth={2.5} data-id="element-105" />
                  Gratis
                </div>
                <div className="aspect-square w-full overflow-hidden bg-brand-cream-alt" data-id="element-106">
                  <img src={bono.image} alt={bono.alt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" data-id="element-107" />
                </div>
                <div className="p-6 flex flex-col gap-2 flex-1" data-id="element-108">
                  <h3 className="text-xl font-serif text-brand-burgundy leading-snug" data-id="element-109">
                    {bono.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed" data-id="element-110">
                    {bono.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </FadeIn>
    </section>;
}